import type {
  IListNotificationsParams,
  IListNotificationsResponse,
  IMarkAsReadResponse,
  IMarkNotificationAsReadParams,
  IRegisterPushTokenParams,
  IRegisterPushTokenResponse,
  IUnreadCountResponse,
  IUnregisterPushTokenParams,
  IUnregisterPushTokenResponse,
} from "../types/notifications";
import type { ApiClient } from "./client";

export class NotificationsApi {
  constructor(private readonly apiClient: ApiClient) {}

  async list(
    params: IListNotificationsParams,
  ): Promise<IListNotificationsResponse> {
    const response = await this.apiClient.get<IListNotificationsResponse>(
      "/notifications",
      { params },
    );
    return response.data;
  }

  async getUnreadCount(): Promise<IUnreadCountResponse> {
    const response = await this.apiClient.get<IUnreadCountResponse>(
      "/notifications/unread-count",
    );
    return response.data;
  }

  async markAsRead({
    uuid,
  }: IMarkNotificationAsReadParams): Promise<IMarkAsReadResponse> {
    const response = await this.apiClient.patch<IMarkAsReadResponse>(
      `/notifications/${uuid}/read`,
    );
    return response.data;
  }

  async markAllAsRead(): Promise<IMarkAsReadResponse> {
    const response = await this.apiClient.patch<IMarkAsReadResponse>(
      "/notifications/read-all",
    );
    return response.data;
  }

  // NOTE: NSAI-4293 — tells the server which device address to deliver
  // OS-level push notifications to. Idempotent: the app calls it on every
  // launch and after any token rotation. POST for the delete too, per the
  // platform convention of distinguishing the action by path.
  //
  // Mobile-only in practice today, but it lives in the shared client because
  // the contract is platform-agnostic and web push would use the same routes.
  async registerPushToken(
    params: IRegisterPushTokenParams,
  ): Promise<IRegisterPushTokenResponse> {
    const response = await this.apiClient.post<IRegisterPushTokenResponse>(
      "/notifications/push-tokens/register",
      params,
    );
    return response.data;
  }

  async unregisterPushToken(
    params: IUnregisterPushTokenParams,
  ): Promise<IUnregisterPushTokenResponse> {
    const response = await this.apiClient.post<IUnregisterPushTokenResponse>(
      "/notifications/push-tokens/unregister",
      params,
    );
    return response.data;
  }
}
